import { acceptHMRUpdate, defineStore } from 'pinia'
import { useRoute } from 'vue-router'
import { log } from "@/services"
import { IncomingMessage } from "@/types"

export const useMessaging = defineStore('messaging', {
    actions: {
        initHandler(handler: Function): string {
            // use parent provided widget id or generate one if none provided
            const route = useRoute()
            const wid = route.query.wid?.toString()
            if (wid === undefined) {
                log.warn("wid is missing")
                return ''
            }

            globalThis.addEventListener('message', (message: MessageEvent<IncomingMessage>) => handler(message.data))
            this.$state.wid = wid
            this.sendToParent(
                {
                    event: "widgetReady",
                    data: null
                },
            )
            return wid
        },
        sendToParent(message: {event: string, data: unknown}) {
            log.debug("Message from widget to parent", {
                    event: message.event,
                    data: message.data,
                    wid: this.$state.wid
                })
            globalThis.parent.postMessage(
                {
                    event: message.event,
                    data: message.data,
                    wid: this.$state.wid
                },
                "*"
            )
        }
    },
    state: () => {
        return {
            wid: '',
        }
    }
})

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useMessaging, import.meta.hot))
}
